import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './FoundationSection.css';
import '../common-styles.css';
import icon1 from '../../assets/images/foundation/1.svg';
import icon2 from '../../assets/images/foundation/2.svg';
import icon3 from '../../assets/images/foundation/3.svg';
import icon4 from '../../assets/images/foundation/4.svg';

interface FoundationPillar {
  id: number;
  title: string;
  description: string;
  image: string; // path to SVG icon
}

const FOUNDATION_PILLARS: FoundationPillar[] = [
  {
    id: 1,
    title: 'Excellence in Craftsmanship',
    description: 'From rough to radiant, we transform each diamond with precision, passion, and decades of expertise. Our manufacturing standards reflect our commitment to beauty, quality, and perfection.',
  image: icon1
  },
  {
    id: 2,
    title: 'Global Integrity',
    description: 'As trusted importers and exporters, we operate with transparency, ethical sourcing, and full compliance. Our global network is built on trust, respect, and long-standing partnerships.',
  image: icon2
  },
  {
    id: 3,
    title: 'Innovation with Purpose',
    description: 'We embrace modern technology while honoring timeless traditions. Whether through advanced cutting techniques or streamlined logistics, innovation powers our progress.',
  image: icon3
  },
  {
    id: 4,
    title: 'Customer-Centric Service',
    description: 'We are more than a supplier—we are your partner. Our success lies in understanding your needs, delivering on promises, and exceeding expectations.',
  image: icon4
  }
];

const FoundationSection: React.FC = () => {
  return (
    <section className="section foundation-section">
      <Container>
        {/* Header */}
        <Row className="foundation-header mb-5">
          <Col>
            <div className="text-center">
              <div className="foundation-badge">FOUNDATION</div>
              <h2 className="section-title">
                <span className="section-title-highlight">Built on Brilliance</span>, Driven by Trust
              </h2>
              <Button className="section-btn">
                <span className="btn-content">
                  Connect Now <i className="fas fa-arrow-right btn-arrow-diagonal" />
                </span>
              </Button>
            </div>
          </Col>
        </Row>

        {/* Foundation Pillars Grid */}
        <Row className="foundation-grid">
          {FOUNDATION_PILLARS.map((pillar) => (
            <Col key={pillar.id} lg={6} className="mb-4">
              <div className="foundation-card">
                <span className="foundation-card-number">0{pillar.id}</span>
                <div className="foundation-card-header">
                  <h3 className="foundation-card-title">{pillar.title}</h3>
                </div>
                <p className="foundation-card-description">{pillar.description}</p>
                <div className="foundation-card-icon">
                  <img src={pillar.image} alt={pillar.title + ' icon'} />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default FoundationSection;
